var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-date-selector"},[_c('el-button',{staticClass:"mt-2",attrs:{"type":"primary","icon":"el-icon-arrow-left","size":"small","circle":""},on:{"click":_vm.selectPrevious}}),_c('el-button',{staticClass:"mt-2",attrs:{"type":"primary","icon":"el-icon-arrow-right","size":"small","circle":""},on:{"click":_vm.selectNext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }